import { Component, OnInit, Inject } from '@angular/core';
import { listPagesDB } from 'src/app/shared/tables/list-pages';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-committes-list',
  templateUrl: './committes-list.component.html',
  styleUrls: ['./committes-list.component.scss']
})
export class CommittesListComponent implements OnInit {

  constructor(private http: HttpClient, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public committes = [];

  ngOnInit() {
    this.http.get<any>(this.api_endpoint+'/committes/').subscribe(
      data => {
        this.committes = data.data;
        // console.log(this.curriculums);
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
  });
  }

}
